




































import { Component, Prop, Vue } from 'vue-property-decorator'

import AppHlsVideo from '@/components/AppHlsVideo.vue'

@Component({
  components: {
    AppHlsVideo
  }
})
export default class extends Vue {
  @Prop(Boolean) readonly muted!: boolean
  @Prop(Boolean) readonly paused!: boolean
  @Prop(Number) readonly duration!: number
  @Prop(Number) readonly time!: number
  @Prop(Number) readonly startTime!: number
  @Prop(Number) readonly endTime!: number

  toTimeText (n: number) {
    function pad (n: number) {
      return n.toString().padStart(2, '0')
    }

    return `${pad(Math.floor(n / 60))}:${pad(n % 60)}`
  }
}
